import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    card: {
      background: 'rgba(255,255,255,0.05)',
      borderRadius: '8px',
      margin: '8px 0px',
      height: '590px',
      '& .card2': {
        height: '200px',
        padding: '16px',
        borderRadius: '8px',
        marginLeft: '16px',
        marginRight: '16px',
      },
      '& .grid': {
        background: 'rgba(255,255,255,0.05)',
        margin: '16px',
        marginBottom: '0px',
        height: '290px',
        borderRadius: '2px',
        position: 'relative',
      },
    },
    buttonGrid: {
      paddingLeft: '16px',
      display: 'inline-flex',
      '& .digitalButton': {
        background: 'rgba(255,255,255,0.09)',
        border: 'none',
        width: '135px',
        whiteSpace: 'nowrap',
      },
    },
    uploadButton: {
      width: '135px',
    },
    stampUploadContainer: {
      border: 'dashed 1.5px #e3dddd6b',
      width: '100 %',
      alignItems: 'center',
      height: '100%',
    },
    stampLabelDiv: {
      marginBottom: '15px',
    },
    uploadIconGrid: {
      cursor: 'pointer',
    },
    checkboxGrid: {
      paddingLeft: '16px',
      '& .checkboxLabel': {
        marginTop: '10px',
        marginLeft: '-15px',
      },
    },
    spanMsg: {
      textDecoration: 'underline',
      paddingRight: '5px',
      paddingLeft: '5px',
      cursor: 'pointer',
    },
    content: {
      display: 'inline-flex',
    },
    errorGrid: {
      display: 'inline-flex',
      paddingLeft: '55px',
    },
    stampImagePreview: {
      height: '160px',
      marginLeft: '10px',
    },
    xfeatherOuterCircle: {
      backgroundColor: '#080908',
      border: '3px solid #080908',
      borderRadius: '50%',
      width: '31px',
      height: '31px',
      marginLeft: '156px',
    },
    xfeatherInnerCircle: {
      borderRadius: '50%',
      backgroundColor: '#080908',
      width: '25px',
      height: '25px',
      border: '1px solid #249236',
    },
    signImageDiv: {
      width: '160px',
      height: '160px',
    },
    signImage: {
      width: '100%',
      height: '80%',
    },
    signUploadContainer: {
      height: '100%',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'center',
    },
    clearSignButton: {
      textAlign: 'right',
      paddingTop: '28px',
      paddingRight: '38px',
    },
    xfeatherOuterCircleStamp: {
      backgroundColor: '#080908',
      border: '3px solid #080908',
      borderRadius: '50%',
      width: '31px',
      height: '31px',
      marginLeft: '156px',
    },
    xfeatherInnerCircleStamp: {
      borderRadius: '50%',
      backgroundColor: '#080908',
      width: '25px',
      height: '25px',
      border: '1px solid #249236',
    },
    stampImageDiv: {
      width: '160px',
      height: '160px',
      display: 'inline-flex',
    },
    stampImage: {
      width: '100%',
      height: '80%',
    },
    imageName: {
      color: 'rgba(255,255,255,0.6)',
      paddingTop: '100px',
      paddingLeft: '15px',
      minWidth: 'max-content',
    },
    signCanvas: {
      width: '100%',
      height: '100%',
    },
    signStampTitle: {
      marginBottom: '10px',
      float: 'right',
      marginTop: '28px',
      marginRight: '23px',
      '& .clearSignText': {
        fontWeight: 700,
        cursor: 'pointer',
      },
    },
    signCenter: {
      margin: 'auto',
    },
    deleteConfirmGrid: {
      padding: 5,
    },
    deleteConfirmContentGrid: {
      padding: '25px 0px 25px 0px',
    },
    loadingStamp: {
      margin: '24px 0px 0px 60px',
    },
    loadingSign: {
      margin: '58px 0px 0px 70px',
    },
  }),
);

export default useStyles;
